(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nityara-product-assurance"] && !Shopify.designMode) return;
  try {
    (()=>{const init=r=>{if(r.dataset.ready)return;r.dataset.ready='1';const motion=r.dataset.motion==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches,els=r.querySelectorAll('.npa-reveal');if(motion&&'IntersectionObserver'in window){r.classList.add('npa--motion');const o=new IntersectionObserver((es,ob)=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');ob.unobserve(e.target)}}),{threshold:.08});els.forEach(e=>o.observe(e))}else els.forEach(e=>e.classList.add('is-visible'));const ds=r.querySelectorAll('.npa__row');ds.forEach(d=>d.addEventListener('toggle',()=>{if(d.open)ds.forEach(x=>{if(x!==d)x.removeAttribute('open')})}))};const all=()=>document.querySelectorAll('[data-npa-root]').forEach(init);document.readyState==='loading'?document.addEventListener('DOMContentLoaded',all,{once:true}):all();document.addEventListener('shopify:section:load',all)})();
  } catch(e) { console.error(e); }
})();

})();
